import React, { useState } from 'react';
import AdminLogin from './components/AdminLogin';
import Dashboard from './components/Dashboard';

function App() {
  const [loggedIn, setLoggedIn] = useState(false);

  return (
    <div>
      {loggedIn ? <Dashboard /> : <AdminLogin onLogin={() => setLoggedIn(true)} />}
    </div>
  );
}

export default App;